import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getDragModality as $7252cd45fc48c07c$export$1fb2158d224b542c, getTypes as $7252cd45fc48c07c$export$e1d41611756c6326 } from "./utils.module.js";
import { announce as $irqIb$announce } from "@react-aria/live-announcer";
import { ariaHideOutside as $irqIb$ariaHideOutside } from "@react-aria/overlays";
import { isVirtualClick as $irqIb$isVirtualClick, isVirtualPointerEvent as $irqIb$isVirtualPointerEvent } from "@react-aria/utils";
import { useState as $irqIb$useState, useEffect as $irqIb$useEffect } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $67560de7c78cb232$var$dropTargets = new Map();
var $67560de7c78cb232$var$dropItems = new Map();
var $67560de7c78cb232$var$dragSession = null;
var $67560de7c78cb232$var$subscriptions = new Set();
function $67560de7c78cb232$export$c28d9fb4a54e471a(target) {
  $67560de7c78cb232$var$dropTargets.set(target.element, target);
  $67560de7c78cb232$var$dragSession === null || $67560de7c78cb232$var$dragSession === void 0 ? void 0 : $67560de7c78cb232$var$dragSession.updateValidDropTargets();
  return function () {
    $67560de7c78cb232$var$dropTargets.delete(target.element);
    $67560de7c78cb232$var$dragSession === null || $67560de7c78cb232$var$dragSession === void 0 ? void 0 : $67560de7c78cb232$var$dragSession.updateValidDropTargets();
  };
}
function $67560de7c78cb232$export$aef80212ac99c003(item) {
  $67560de7c78cb232$var$dropItems.set(item.element, item);
  return function () {
    $67560de7c78cb232$var$dropItems.delete(item.element);
  };
}
function $67560de7c78cb232$export$549dbcf8649bf3b2(target, stringFormatter) {
  if ($67560de7c78cb232$var$dragSession) throw new Error('Cannot begin dragging while already dragging');
  $67560de7c78cb232$var$dragSession = new $67560de7c78cb232$var$DragSession(target, stringFormatter);
  requestAnimationFrame(function () {
    $67560de7c78cb232$var$dragSession.setup();
    if ((0, $7252cd45fc48c07c$export$1fb2158d224b542c)() === 'keyboard') $67560de7c78cb232$var$dragSession.next();
  });
  var _iterator = _createForOfIteratorHelper($67560de7c78cb232$var$subscriptions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cb = _step.value;
      cb();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function $67560de7c78cb232$export$418e185dd3f1b968() {
  var _ref = (0, $irqIb$useState)($67560de7c78cb232$var$dragSession),
    _ref2 = _slicedToArray(_ref, 2),
    session = _ref2[0],
    setSession = _ref2[1];
  (0, $irqIb$useEffect)(function () {
    var cb = function cb() {
      return setSession($67560de7c78cb232$var$dragSession);
    };
    $67560de7c78cb232$var$subscriptions.add(cb);
    return function () {
      $67560de7c78cb232$var$subscriptions.delete(cb);
    };
  }, []);
  return session;
}
function $67560de7c78cb232$export$403bc76cbf68cf60() {
  return !!$67560de7c78cb232$var$dragSession;
}
function $67560de7c78cb232$var$endDragging() {
  $67560de7c78cb232$var$dragSession = null;
  var _iterator2 = _createForOfIteratorHelper($67560de7c78cb232$var$subscriptions),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var cb = _step2.value;
      cb();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function $67560de7c78cb232$export$7454aff2e161f241(element) {
  var _iterator3 = _createForOfIteratorHelper($67560de7c78cb232$var$dropTargets.keys()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var target = _step3.value;
      if (target.contains(element)) return true;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
}
var $67560de7c78cb232$var$CANCELED_EVENTS = ['pointerdown', 'pointermove', 'pointerenter', 'pointerleave', 'pointerover', 'pointerout', 'pointerup', 'mousedown', 'mousemove', 'mouseenter', 'mouseleave', 'mouseover', 'mouseout', 'mouseup', 'touchstart', 'touchmove', 'touchend', 'focusin', 'focusout'];
var $67560de7c78cb232$var$CLICK_EVENTS = ['pointerup', 'mouseup', 'touchend'];
var $67560de7c78cb232$var$MESSAGES = {
  keyboard: 'dragStartedKeyboard',
  touch: 'dragStartedTouch',
  virtual: 'dragStartedVirtual'
};
var $67560de7c78cb232$var$DragSession = /*#__PURE__*/function () {
  _createClass($67560de7c78cb232$var$DragSession, [{
    key: "setup",
    value: function setup() {
      var _this = this;
      document.addEventListener('keydown', this.onKeyDown, true);
      document.addEventListener('keyup', this.onKeyUp, true);
      window.addEventListener('focus', this.onFocus, true);
      window.addEventListener('blur', this.onBlur, true);
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('pointerdown', this.onPointerDown, true);
      for (var _i = 0, _$67560de7c78cb232$va = $67560de7c78cb232$var$CANCELED_EVENTS; _i < _$67560de7c78cb232$va.length; _i++) {
        var event = _$67560de7c78cb232$va[_i];
        document.addEventListener(event, this.cancelEvent, true);
      }
      this.mutationObserver = new MutationObserver(function () {
        return _this.updateValidDropTargets();
      });
      this.updateValidDropTargets();
      (0, $irqIb$announce)(this.stringFormatter.format($67560de7c78cb232$var$MESSAGES[(0, $7252cd45fc48c07c$export$1fb2158d224b542c)()]));
    }
  }, {
    key: "teardown",
    value: function teardown() {
      document.removeEventListener('keydown', this.onKeyDown, true);
      document.removeEventListener('keyup', this.onKeyUp, true);
      window.removeEventListener('focus', this.onFocus, true);
      window.removeEventListener('blur', this.onBlur, true);
      document.removeEventListener('click', this.onClick, true);
      document.removeEventListener('pointerdown', this.onPointerDown, true);
      for (var _i2 = 0, _$67560de7c78cb232$va2 = $67560de7c78cb232$var$CANCELED_EVENTS; _i2 < _$67560de7c78cb232$va2.length; _i2++) {
        var event = _$67560de7c78cb232$va2[_i2];
        document.removeEventListener(event, this.cancelEvent, true);
      }
      this.mutationObserver.disconnect();
      this.restoreAriaHidden();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this_currentDropTarget;
      this.cancelEvent(e);
      if (e.key === 'Escape') {
        this.cancel();
        return;
      }
      if (e.key === 'Tab' && !(e.metaKey || e.altKey || e.ctrlKey)) {
        if (e.shiftKey) this.previous();else this.next();
      }
      if (typeof ((_this_currentDropTarget = this.currentDropTarget) === null || _this_currentDropTarget === void 0 ? void 0 : _this_currentDropTarget.onKeyDown) === 'function') this.currentDropTarget.onKeyDown(e, this.dragTarget);
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      this.cancelEvent(e);
      if (e.key === 'Enter') {
        if (e.altKey) this.activate();else this.drop();
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      // Prevent focus events, except to the original drag target.
      if (e.target !== this.dragTarget.element) this.cancelEvent(e);
      // Ignore focus events on the window/document (JSDOM). Will be handled in onBlur, below.
      if (!(e.target instanceof HTMLElement) || e.target === this.dragTarget.element) return;
      var dropTarget = this.validDropTargets.find(function (target) {
        return target.element === e.target;
      }) || this.validDropTargets.find(function (target) {
        return target.element.contains(e.target);
      });
      if (!dropTarget) {
        if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
        return;
      }
      var item = $67560de7c78cb232$var$dropItems.get(e.target);
      this.setCurrentDropTarget(dropTarget, item);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      if (e.target !== this.dragTarget.element) this.cancelEvent(e);
      // If nothing is gaining focus, or e.relatedTarget is the window/document (JSDOM),
      // restore focus back to the current drop target if any, or the original drag target.
      if (!e.relatedTarget || !(e.relatedTarget instanceof HTMLElement)) {
        if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.cancelEvent(e);
      if ((0, $irqIb$isVirtualClick)(e) || this.isVirtualClick) {
        if (e.target === this.dragTarget.element) {
          this.cancel();
          return;
        }
        var dropTarget = this.validDropTargets.find(function (target) {
          return target.element.contains(e.target);
        });
        if (dropTarget) {
          var item = $67560de7c78cb232$var$dropItems.get(e.target);
          this.setCurrentDropTarget(dropTarget, item);
          this.drop(item);
        }
      }
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(e) {
      // Android Talkback double tap has e.detail = 1 for onClick. Detect the virtual click in onPointerDown before onClick fires
      // so we can properly perform cancel and drop operations.
      this.cancelEvent(e);
      this.isVirtualClick = (0, $irqIb$isVirtualPointerEvent)(e);
    }
  }, {
    key: "cancelEvent",
    value: function cancelEvent(e) {
      var _this_dragTarget;
      // Allow focusin and focusout on the drag target so focus ring works properly.
      if ((e.type === 'focusin' || e.type === 'focusout') && e.target === ((_this_dragTarget = this.dragTarget) === null || _this_dragTarget === void 0 ? void 0 : _this_dragTarget.element)) return;
      // Allow default for events that might cancel a click event
      if (!$67560de7c78cb232$var$CLICK_EVENTS.includes(e.type)) e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, {
    key: "updateValidDropTargets",
    value: function updateValidDropTargets() {
      var _this2 = this;
      if (!this.mutationObserver) return;
      this.mutationObserver.disconnect();
      if (this.restoreAriaHidden) this.restoreAriaHidden();
      this.validDropTargets = $67560de7c78cb232$var$findValidDropTargets(this.dragTarget);
      // Shuffle drop target order based on starting drag target.
      if (this.validDropTargets.length > 0) {
        var nearestIndex = this.findNearestDropTarget();
        this.validDropTargets = [].concat(_toConsumableArray(this.validDropTargets.slice(nearestIndex)), _toConsumableArray(this.validDropTargets.slice(0, nearestIndex)));
      }
      if (this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget)) this.setCurrentDropTarget(this.validDropTargets[0]);
      // Find valid drop items within collections
      var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
      var validDropItems = _toConsumableArray($67560de7c78cb232$var$dropItems.values()).filter(function (item) {
        if (typeof item.getDropOperation === 'function') return item.getDropOperation(types, _this2.dragTarget.allowedDropOperations) !== 'cancel';
        return true;
      });
      // Filter out drop targets that contain valid items. We don't want to stop hiding elements
      // other than the drop items that exist inside the collection.
      var visibleDropTargets = this.validDropTargets.filter(function (target) {
        return !validDropItems.some(function (item) {
          return target.element.contains(item.element);
        });
      });
      this.restoreAriaHidden = (0, $irqIb$ariaHideOutside)([this.dragTarget.element].concat(_toConsumableArray(validDropItems.map(function (item) {
        return item.element;
      })), _toConsumableArray(visibleDropTargets.map(function (target) {
        return target.element;
      }))));
      this.mutationObserver.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
  }, {
    key: "next",
    value: function next() {
      if (!this.currentDropTarget) {
        this.setCurrentDropTarget(this.validDropTargets[0]);
        return;
      }
      var index = this.validDropTargets.indexOf(this.currentDropTarget);
      if (index < 0) {
        this.setCurrentDropTarget(this.validDropTargets[0]);
        return;
      }
      // If we've reached the end of the valid drop targets, cycle back to the original drag target.
      // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
      if (index === this.validDropTargets.length - 1) {
        if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
          this.setCurrentDropTarget(null);
          this.dragTarget.element.focus();
        } else this.setCurrentDropTarget(this.validDropTargets[0]);
      } else this.setCurrentDropTarget(this.validDropTargets[index + 1]);
    }
  }, {
    key: "previous",
    value: function previous() {
      if (!this.currentDropTarget) {
        this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        return;
      }
      var index = this.validDropTargets.indexOf(this.currentDropTarget);
      if (index < 0) {
        this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        return;
      }
      // If we've reached the start of the valid drop targets, cycle back to the original drag target.
      // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
      if (index === 0) {
        if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
          this.setCurrentDropTarget(null);
          this.dragTarget.element.focus();
        } else this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
      } else this.setCurrentDropTarget(this.validDropTargets[index - 1]);
    }
  }, {
    key: "findNearestDropTarget",
    value: function findNearestDropTarget() {
      var dragTargetRect = this.dragTarget.element.getBoundingClientRect();
      var minDistance = Infinity;
      var nearest = -1;
      for (var i = 0; i < this.validDropTargets.length; i++) {
        var dropTarget = this.validDropTargets[i];
        var rect = dropTarget.element.getBoundingClientRect();
        var dx = rect.left - dragTargetRect.left;
        var dy = rect.top - dragTargetRect.top;
        var dist = dx * dx + dy * dy;
        if (dist < minDistance) {
          minDistance = dist;
          nearest = i;
        }
      }
      return nearest;
    }
  }, {
    key: "setCurrentDropTarget",
    value: function setCurrentDropTarget(dropTarget, item) {
      if (dropTarget !== this.currentDropTarget) {
        if (this.currentDropTarget && typeof this.currentDropTarget.onDropExit === 'function') {
          var rect = this.currentDropTarget.element.getBoundingClientRect();
          this.currentDropTarget.onDropExit({
            type: 'dropexit',
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
          });
        }
        this.currentDropTarget = dropTarget;
        if (dropTarget) {
          if (typeof dropTarget.onDropEnter === 'function') {
            var _rect = dropTarget.element.getBoundingClientRect();
            dropTarget.onDropEnter({
              type: 'dropenter',
              x: _rect.left + _rect.width / 2,
              y: _rect.top + _rect.height / 2
            }, this.dragTarget);
          }
          if (!item) dropTarget === null || dropTarget === void 0 ? void 0 : dropTarget.element.focus();
        }
      }
      if (item !== this.currentDropItem) {
        if (item && typeof this.currentDropTarget.onDropTargetEnter === 'function') this.currentDropTarget.onDropTargetEnter(item === null || item === void 0 ? void 0 : item.target);
        item === null || item === void 0 ? void 0 : item.element.focus();
        this.currentDropItem = item;
        // Announce first drop target after drag start announcement finishes.
        // Otherwise, it will never get announced because drag start announcement is assertive.
        if (!this.initialFocused) {
          (0, $irqIb$announce)(item === null || item === void 0 ? void 0 : item.element.getAttribute('aria-label'), 'polite');
          this.initialFocused = true;
        }
      }
    }
  }, {
    key: "end",
    value: function end() {
      this.teardown();
      $67560de7c78cb232$var$endDragging();
      if (typeof this.dragTarget.onDragEnd === 'function') {
        var target = this.currentDropTarget && this.dropOperation !== 'cancel' ? this.currentDropTarget : this.dragTarget;
        var rect = target.element.getBoundingClientRect();
        this.dragTarget.onDragEnd({
          type: 'dragend',
          x: rect.x + rect.width / 2,
          y: rect.y + rect.height / 2,
          dropOperation: this.dropOperation || 'cancel'
        });
      }
      if (this.currentDropTarget && !this.currentDropTarget.preventFocusOnDrop)
        // Re-trigger focus event on active element, since it will not have received it during dragging (see cancelEvent).
        // This corrects state such as whether focus ring should appear.
        // useDroppableCollection handles this itself, so this is only for standalone drop zones.
        document.activeElement.dispatchEvent(new FocusEvent('focusin', {
          bubbles: true
        }));
      this.setCurrentDropTarget(null);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.setCurrentDropTarget(null);
      this.end();
      if (!this.dragTarget.element.closest('[aria-hidden="true"]')) this.dragTarget.element.focus();
      (0, $irqIb$announce)(this.stringFormatter.format('dropCanceled'));
    }
  }, {
    key: "drop",
    value: function drop(item) {
      if (!this.currentDropTarget) {
        this.cancel();
        return;
      }
      if (typeof (item === null || item === void 0 ? void 0 : item.getDropOperation) === 'function') {
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
        this.dropOperation = item.getDropOperation(types, this.dragTarget.allowedDropOperations);
      } else if (typeof this.currentDropTarget.getDropOperation === 'function') {
        var _types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(this.dragTarget.items);
        this.dropOperation = this.currentDropTarget.getDropOperation(_types, this.dragTarget.allowedDropOperations);
      } else
        // TODO: show menu ??
        this.dropOperation = this.dragTarget.allowedDropOperations[0];
      if (typeof this.currentDropTarget.onDrop === 'function') {
        var items = this.dragTarget.items.map(function (item) {
          return {
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: function getText(type) {
              return Promise.resolve(item[type]);
            }
          };
        });
        var rect = this.currentDropTarget.element.getBoundingClientRect();
        this.currentDropTarget.onDrop({
          type: 'drop',
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
          items: items,
          dropOperation: this.dropOperation
        }, item === null || item === void 0 ? void 0 : item.target);
      }
      this.end();
      (0, $irqIb$announce)(this.stringFormatter.format('dropComplete'));
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.currentDropTarget && typeof this.currentDropTarget.onDropActivate === 'function') {
        var rect = this.currentDropTarget.element.getBoundingClientRect();
        this.currentDropTarget.onDropActivate({
          type: 'dropactivate',
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2
        });
      }
    }
  }]);
  function $67560de7c78cb232$var$DragSession(target, stringFormatter) {
    _classCallCheck(this, $67560de7c78cb232$var$DragSession);
    this.dragTarget = target;
    this.stringFormatter = stringFormatter;
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.cancelEvent = this.cancelEvent.bind(this);
    this.initialFocused = false;
  }
  return $67560de7c78cb232$var$DragSession;
}();
function $67560de7c78cb232$var$findValidDropTargets(options) {
  var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(options.items);
  return _toConsumableArray($67560de7c78cb232$var$dropTargets.values()).filter(function (target) {
    if (target.element.closest('[aria-hidden="true"]')) return false;
    if (typeof target.getDropOperation === 'function') return target.getDropOperation(types, options.allowedDropOperations) !== 'cancel';
    return true;
  });
}
export { $67560de7c78cb232$export$c28d9fb4a54e471a as registerDropTarget, $67560de7c78cb232$export$aef80212ac99c003 as registerDropItem, $67560de7c78cb232$export$549dbcf8649bf3b2 as beginDragging, $67560de7c78cb232$export$418e185dd3f1b968 as useDragSession, $67560de7c78cb232$export$403bc76cbf68cf60 as isVirtualDragging, $67560de7c78cb232$export$7454aff2e161f241 as isValidDropTarget };